import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import axios from "axios";

/**
 * /i-get-to-deck — SNEAK PEEK + WAITLIST for the NEW 55-card I GET TO deck
 * Status: Coming Soon. Shows 6 sample cards + MailerLite waitlist signup.
 */

const API_URL = process.env.REACT_APP_BACKEND_URL;
const WAITLIST_GROUP = "i-get-to-deck-waitlist";

const BRAND = {
  teal: "#068fa2",
  tealDeep: "#0a5b6a",
  cream: "#efeae7",
  gold: "#d4af6a",
  orange: "#e8a06b",
  ink: "#042f2e",
};

// Sneak peek cards (NOT the full 55 — just 6 to whet the appetite)
const SNEAK_PEEK = [
  { src: "/i-get-to-deck/card-00.png", label: "The Deck Cover" },
  { src: "/i-get-to-deck/card-01.png", label: "An Awakening Card" },
  { src: "/i-get-to-deck/card-02.png", label: "A Clarity Card" },
  { src: "/i-get-to-deck/card-03.png", label: "A Tapped-In Card" },
  { src: "/i-get-to-deck/card-04.png", label: "A NOW Card" },
  { src: "/i-get-to-deck/card-05.png", label: "A Daily-Practice Card" },
];

export default function IGetToDeckPage() {
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [status, setStatus] = useState("idle"); // idle | submitting | success | error
  const [errorMsg, setErrorMsg] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || status === "submitting") return;
    setStatus("submitting");
    setErrorMsg("");
    try {
      await axios.post(`${API_URL}/api/subscribe`, {
        email: email.trim().toLowerCase(),
        firstName: firstName.trim() || "Friend",
        group_id: WAITLIST_GROUP,
      });
      setStatus("success");
    } catch (err) {
      setStatus("error");
      setErrorMsg(
        err?.response?.data?.detail ||
          "Something hiccupped. Please try again in a moment."
      );
    }
  };

  return (
    <div
      data-testid="i-get-to-deck-page"
      style={{ backgroundColor: BRAND.cream, minHeight: "100vh", color: BRAND.ink }}
    >
      <Helmet>
        <title>The "I GET TO" Card Deck — 55 Daily Ritual Cards | Mind Body Spirit HYGIENE™</title>
        <meta
          name="description"
          content="55 grounded, beautifully designed daily ritual cards by Temple Franklin. Pull one card, get one shift, one small practice. Stop saying 'I have to' — start living 'I GET TO.' Digital deck $2.22. Available now."
        />
        <meta name="keywords" content="I GET TO, affirmation cards, daily ritual deck, Temple Franklin, Mind Body Spirit HYGIENE™, intention cards, morning practice deck" />
        <link rel="canonical" href="https://mindbodyspirithygienetools.com/i-get-to-deck" />
        <meta property="og:type" content="product" />
        <meta property="og:title" content="The I GET TO Card Deck — 55 Daily Cards" />
        <meta property="og:description" content="One card. One shift. One small practice. Built to be used, not displayed. $2.22 digital deck. Available now." />
        <meta property="og:image" content="https://mindbodyspirithygienetools.com/i-get-to-deck/card-00.png" />
        <meta property="og:url" content="https://mindbodyspirithygienetools.com/i-get-to-deck" />
        <meta name="twitter:card" content="summary_large_image" />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Product",
          "name": "The I GET TO Card Deck",
          "description": "55 daily ritual cards. Pull one card, get one shift, one small practice. Digital download.",
          "brand": {"@type": "Brand", "name": "Mind Body Spirit HYGIENE\u2122"},
          "image": "https://mindbodyspirithygienetools.com/i-get-to-deck/card-00.png",
          "offers": {"@type": "Offer", "price": "2.22", "priceCurrency": "USD", "availability": "https://schema.org/InStock", "url": "https://templefranklin22.gumroad.com/l/wscmew"}
        })}</script>
      </Helmet>
      {/* ── HERO ─────────────────────────────────────────── */}
      <section className="px-6 pt-16 pb-12 md:pt-24 md:pb-20 text-center max-w-4xl mx-auto">
        <div
          data-testid="coming-soon-badge"
          className="inline-block uppercase tracking-[0.25em] text-xs md:text-sm px-5 py-2 rounded-full mb-8"
          style={{
            backgroundColor: BRAND.teal,
            color: BRAND.cream,
            letterSpacing: "0.3em",
          }}
        >
          ✦ Now Available ✦
        </div>

        <h1
          className="text-4xl sm:text-5xl lg:text-6xl mb-6"
          style={{ fontFamily: "Georgia, serif", color: BRAND.tealDeep, lineHeight: 1.1 }}
        >
          The{" "}
          <span style={{ fontStyle: "italic", color: BRAND.gold }}>
            I GET TO
          </span>{" "}
          Card Deck
        </h1>

        <p
          className="text-base md:text-lg mb-3 italic"
          style={{ color: BRAND.tealDeep, opacity: 0.85 }}
        >
          55 cards · Mind Body Spirit HYGIENE™ Tools
        </p>

        <p
          className="text-base md:text-lg max-w-2xl mx-auto mt-8 leading-relaxed"
          style={{ color: BRAND.ink, opacity: 0.85 }}
        >
          A grounded, beautifully designed daily ritual deck — one card, one
          shift, one small practice. Built to be used, not displayed.
        </p>

        <p
          className="text-3xl md:text-4xl mt-8 mb-2"
          style={{ color: BRAND.tealDeep, fontFamily: "Georgia, serif", fontWeight: 700 }}
        >
          $2.22
        </p>
        <p className="text-sm italic mb-6" style={{ color: BRAND.teal, opacity: 0.85 }}>
          Digital download · instant PDF · use on phone or print at home
        </p>

        <a
          href="https://templefranklin22.gumroad.com/l/wscmew"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="buy-now-btn"
          className="inline-block px-10 py-4 rounded-md uppercase tracking-[0.2em] text-sm md:text-base transition-opacity hover:opacity-90"
          style={{
            backgroundColor: BRAND.tealDeep,
            color: BRAND.cream,
            fontWeight: 600,
          }}
        >
          Buy on Gumroad · $2.22 →
        </a>
      </section>

      {/* ── SNEAK PEEK GALLERY ───────────────────────────── */}
      <section className="px-6 pb-16 max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <p
            className="uppercase tracking-[0.3em] text-xs mb-2"
            style={{ color: BRAND.gold }}
          >
            ✦ Sneak Peek ✦
          </p>
          <h2
            className="text-2xl md:text-3xl"
            style={{ fontFamily: "Georgia, serif", color: BRAND.tealDeep }}
          >
            A few cards from the deck
          </h2>
          <p className="text-sm md:text-base mt-3 italic" style={{ opacity: 0.7 }}>
            (Six of the fifty-five — the rest are still in the temple.)
          </p>
        </div>

        <div
          className="grid grid-cols-2 md:grid-cols-3 gap-5 md:gap-7"
          data-testid="sneak-peek-gallery"
        >
          {SNEAK_PEEK.map((c, i) => (
            <div
              key={c.src}
              data-testid={`sneak-card-${i}`}
              className="rounded-lg overflow-hidden shadow-lg transition-transform duration-300 hover:scale-[1.03] hover:shadow-2xl"
              style={{ backgroundColor: "#fff", border: `1px solid ${BRAND.gold}40` }}
            >
              <img
                src={c.src}
                alt={c.label}
                className="w-full h-auto block"
                loading="lazy"
              />
            </div>
          ))}
        </div>

        <p
          className="text-center text-sm italic mt-8"
          style={{ color: BRAND.tealDeep, opacity: 0.7 }}
        >
          The remaining 49 cards stay sealed until launch day.
        </p>
      </section>

      {/* ── WAITLIST FORM ────────────────────────────────── */}
      <section
        className="px-6 py-16 md:py-20"
        style={{ backgroundColor: BRAND.tealDeep, color: BRAND.cream }}
      >
        <div className="max-w-xl mx-auto text-center">
          {status === "success" ? (
            <div data-testid="waitlist-success">
              <p
                className="uppercase tracking-[0.25em] text-xs mb-4"
                style={{ color: BRAND.gold }}
              >
                ✦ You're on the list ✦
              </p>
              <h3
                className="text-3xl md:text-4xl mb-5"
                style={{ fontFamily: "Georgia, serif" }}
              >
                Welcome home.
              </h3>
              <p className="text-base md:text-lg leading-relaxed opacity-90">
                I'll write to you the moment the deck is in my hands. First 100
                on the list get the launch-day discount and a free shipping
                bonus. Watch your inbox.
              </p>
              <p className="text-sm italic mt-6 opacity-75">
                — Temple
              </p>
            </div>
          ) : (
            <>
              <p
                className="uppercase tracking-[0.25em] text-xs mb-4"
                style={{ color: BRAND.gold }}
              >
                ✦ Join the waitlist ✦
              </p>
              <h3
                className="text-3xl md:text-4xl mb-4"
                style={{ fontFamily: "Georgia, serif" }}
              >
                Be first to pull a card.
              </h3>
              <p className="text-base mb-8 opacity-90 leading-relaxed">
                The deck launches summer 2026. Get on the list and I'll send
                you the launch-day link with a discount + a free printable
                "How to Use Your Deck" guide.
              </p>

              <form
                onSubmit={handleSubmit}
                className="space-y-4"
                data-testid="waitlist-form"
              >
                <input
                  data-testid="waitlist-firstname"
                  type="text"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  placeholder="First name (optional)"
                  className="w-full px-5 py-3 rounded-md text-base"
                  style={{
                    backgroundColor: BRAND.cream,
                    color: BRAND.ink,
                    border: "none",
                  }}
                />
                <input
                  data-testid="waitlist-email"
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Your email"
                  className="w-full px-5 py-3 rounded-md text-base"
                  style={{
                    backgroundColor: BRAND.cream,
                    color: BRAND.ink,
                    border: "none",
                  }}
                />
                <button
                  data-testid="waitlist-submit"
                  type="submit"
                  disabled={status === "submitting"}
                  className="w-full px-6 py-3 rounded-md text-base uppercase tracking-[0.2em] transition-opacity disabled:opacity-60"
                  style={{
                    backgroundColor: BRAND.gold,
                    color: BRAND.ink,
                    fontWeight: 600,
                  }}
                >
                  {status === "submitting"
                    ? "Adding you…"
                    : "Reserve my spot"}
                </button>
                {status === "error" && (
                  <p
                    data-testid="waitlist-error"
                    className="text-sm mt-2"
                    style={{ color: "#ffd6c2" }}
                  >
                    {errorMsg}
                  </p>
                )}
              </form>

              <p className="text-xs italic mt-6 opacity-70">
                No spam. Unsubscribe anytime. Just the launch + the discount.
              </p>
            </>
          )}
        </div>
      </section>

      {/* ── FOOTER LINKS ─────────────────────────────────── */}
      <section className="px-6 py-10 text-center text-sm" style={{ opacity: 0.75 }}>
        <p>
          While you wait —{" "}
          <Link
            to="/draw"
            data-testid="link-free-card-pull"
            style={{ color: BRAND.teal, textDecoration: "underline" }}
          >
            pull a free card from the current deck
          </Link>{" "}
          · or{" "}
          <Link
            to="/book"
            data-testid="link-book"
            style={{ color: BRAND.teal, textDecoration: "underline" }}
          >
            preview the book
          </Link>
          .
        </p>
        <p className="mt-3 italic" style={{ opacity: 0.7 }}>
          Mind Body Spirit HYGIENE™ · mindbodyspirithygiene.com
        </p>
      </section>
    </div>
  );
}
